import { calcAutoScale, calcBoundingBox } from "@/utils/hengeUtil";
import { useMemo } from "react";
import { useUtilityObjects } from "@/hooks/useUtilityObjects";
import { HngVector3 } from "@/utils/threeUtil";

interface HengeErrorFallbackProps {
  position: HngVector3;
  size: HngVector3;
}

export const HengeErrorFallback = ({
  position,
  size,
}: HengeErrorFallbackProps) => {
  const { errorObjectGLTF } = useUtilityObjects();

  const [cloneObject] = useMemo(() => {
    const object = errorObjectGLTF.scene.clone();

    object.traverse((o) => {
      o.castShadow = true;
      o.receiveShadow = true;
    });

    const boundingBox = calcBoundingBox(object);
    object.userData.boundingBox = boundingBox;

    const autoScale = calcAutoScale(object);
    object.userData.autoScale = autoScale;

    return [object];
  }, []);

  return (
    <group
      position={[position.x, position.y, position.z]}
      scale={[
        cloneObject.userData.autoScale * size.x,
        cloneObject.userData.autoScale * size.y,
        cloneObject.userData.autoScale * size.z,
      ]}
    >
      <primitive object={cloneObject} />
      <mesh
        visible={false}
        position={[
          0,
          (cloneObject.userData.boundingBox.max.y -
            cloneObject.userData.boundingBox.min.y) /
            2,
          0,
        ]}
        scale={[
          (cloneObject.userData.boundingBox.max.x -
            cloneObject.userData.boundingBox.min.x) /
            2,
          (cloneObject.userData.boundingBox.max.y -
            cloneObject.userData.boundingBox.min.y) /
            2,
          (cloneObject.userData.boundingBox.max.z -
            cloneObject.userData.boundingBox.min.z) /
            2,
        ]}
      >
        <sphereGeometry args={[1, 32, 16]} />
        <meshStandardMaterial color={0x0000ff} wireframe />
      </mesh>
    </group>
  );
};
